module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Light-e52d0ec332b3baa19a7e974c843050f8.svg";